'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.paintItem = exports.paintActions = undefined;

var _DrawingModes = require('./DrawingModes');

var _color = require('color');

var _color2 = _interopRequireDefault(_color);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var paintActions = exports.paintActions = function paintActions(ctx, actions, drawing, _ref) {
    var _ref$lassoOutlineColo = _ref.lassoOutlineColor,
        lassoOutlineColor = _ref$lassoOutlineColo === undefined ? '#7DF9FF' : _ref$lassoOutlineColo;

    if (!actions) {
        return;
    }
    if (!Array.isArray(actions)) {
        actions = [actions];
    }
    actions.forEach(function (item) {
        return paintItem(ctx, item, drawing, { lassoOutlineColor: lassoOutlineColor });
    });
};

var paintItem = exports.paintItem = function paintItem(ctx, _ref2, drawing, _ref3) {
    var brushColor = _ref2.brushColor,
        brushSize = _ref2.brushSize,
        brushBlur = _ref2.brushBlur,
        path = _ref2.path,
        mode = _ref2.mode,
        shape = _ref2.shape;
    var _ref3$lassoOutlineCol = _ref3.lassoOutlineColor,
        lassoOutlineColor = _ref3$lassoOutlineCol === undefined ? '#7DF9FF' : _ref3$lassoOutlineCol;

    if (!mode) {
        return;
    }
    if (shape === _DrawingModes.RECT) {
        if (path.length !== 2) {
            return;
        }
        var pt1 = path[0];
        var pt2 = path[1];
        var left = Math.min(pt1.x, pt2.x);
        var top = Math.min(pt1.y, pt2.y);
        var rectWidth = Math.abs(pt1.x - pt2.x);
        var rectHeight = Math.abs(pt1.y - pt2.y);
        ctx.beginPath();
        ctx.lineWidth = 1;
        ctx.strokeStyle = lassoOutlineColor;
        ctx.rect(left, top, rectWidth, rectHeight);
        if (!drawing) {
            ctx.fillStyle = brushColor;
            if (mode === _DrawingModes.INVERSE) {
                ctx.save();
                ctx.setTransform(1, 0, 0, 1, 0, 0);
                ctx.rect(0, 0, ctx.canvas.width, ctx.canvas.height);
                ctx.restore();
                ctx.fill('evenodd');
            } else {
                ctx.fill();
            }
        }
        ctx.stroke();
    } else if (path.length === 1 && brushBlur === 0) {
        var radius = mode === _DrawingModes.LASSO || mode === _DrawingModes.INVERSE ? 1 : brushSize / 2 - 1;
        ctx.beginPath();
        ctx.fillStyle = brushColor;
        ctx.strokeStyle = brushColor;
        ctx.lineWidth = 1;
        ctx.arc(path[0].x, path[0].y, radius, 0, 2 * Math.PI, false);
        ctx.fill();
        ctx.stroke();
    } else {
        ctx.beginPath();
        ctx.strokeStyle = mode === _DrawingModes.BRUSH ? brushColor : lassoOutlineColor;
        ctx.lineWidth = mode === _DrawingModes.LASSO || mode === _DrawingModes.INVERSE ? 3 : brushSize;
        ctx.lineCap = 'round';
        ctx.lineJoin = 'round';

        if (mode === _DrawingModes.BRUSH) {
            ctx.moveTo(path[0].x, path[0].y);
            paintBrushItem(ctx, path, brushSize, brushBlur, brushColor);
        } else {
            path.forEach(function (point, index) {
                if (index === 0) {
                    ctx.moveTo(point.x, point.y);
                } else {
                    ctx.lineTo(point.x, point.y);
                }
            });
            if (!drawing) {
                ctx.closePath();
                if (mode === _DrawingModes.LASSO) {
                    ctx.fillStyle = brushColor;
                    ctx.fill();
                    ctx.stroke();
                } else if (mode === _DrawingModes.INVERSE) {
                    ctx.fillStyle = brushColor;
                    ctx.save();
                    ctx.setTransform(1, 0, 0, 1, 0, 0);
                    ctx.rect(0, 0, ctx.canvas.width, ctx.canvas.height);
                    ctx.restore();
                    ctx.fill('evenodd');
                }
            }
            ctx.stroke();
        }
    }
};

var paintBrushItem = function paintBrushItem(ctx, path, brushSize, brushBlur, brushColor) {
    if (brushBlur !== 0) {
        // soft
        var color = (0, _color2.default)(brushColor);
        var c0 = color.alpha(0).string();
        var c1 = color.alpha(1).string();
        var w = brushSize / 2;
        var s = brushBlur / 101; //TODO: Make maximum blur higher
        for (var pointInd = 0; pointInd < path.length; pointInd += 1) {
            var x = path[pointInd].x;
            var y = path[pointInd].y;
            var dist = 1,
                dirX = 0,
                dirY = 0;
            if (pointInd < path.length - 1) {
                var nextX = path[pointInd + 1].x;
                var nextY = path[pointInd + 1].y;
                dist = Math.sqrt((nextX - x) * (nextX - x) + (nextY - y) * (nextY - y));
                var angle = Math.atan2(nextX - x, nextY - y);
                dirX = Math.sin(angle);
                dirY = Math.cos(angle);
            }

            for (var i = 0; i < dist; i += 5) {
                var currX = x + dirX * i;
                var currY = y + dirY * i;

                var radgrad = ctx.createRadialGradient(currX, currY, w, currX, currY, 0);

                radgrad.addColorStop(0, c0);
                if (s < 0.5) {
                    radgrad.addColorStop(2 * s, c1);
                } else {
                    radgrad.addColorStop(1, color.alpha((1 - s) * 2).string());
                }

                ctx.fillStyle = radgrad;
                ctx.fillRect(currX - w, currY - w, 2 * w, 2 * w);
            }
        }
    } else {
        path.forEach(function (point) {
            ctx.strokeStyle = brushColor;
            ctx.lineWidth = brushSize;
            ctx.lineCap = 'round';
            ctx.lineJoin = 'round';
            ctx.lineTo(point.x, point.y);
            ctx.stroke();
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ../rc-canvas/lib/Paint.js
// module id = 353
// module chunks = 0